import { Box, Paper, Typography, Button, styled, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';

const OverlayContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backdropFilter: 'blur(3px)',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: theme.zIndex.modal,
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: '0',
  maxWidth: 450,
  width: '90%',
  textAlign: 'center',
  position: 'relative',
  backgroundColor: theme.palette.mode === 'dark' ? '#1a1f36' : '#ffffff',
  borderRadius: '4px',
  boxShadow: theme.shadows[5],
  overflow: 'hidden'
}));

const ModalHeader = styled(Box)(({ theme }) => ({
  padding: '16px 24px',
  borderBottom: `1px solid ${theme.palette.mode === 'dark' ? '#30384a' : '#e0e0e0'}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

const ModalContent = styled(Box)(({ theme }) => ({
  padding: '24px',
  textAlign: 'left',
}));

const ModalFooter = styled(Box)(({ theme }) => ({
  padding: '16px 24px',
  borderTop: `1px solid ${theme.palette.mode === 'dark' ? '#30384a' : '#e0e0e0'}`,
  display: 'flex',
  justifyContent: 'flex-end',
}));

interface SessionExpiredOverlayProps {
  onRelogin: () => void;
  message?: string;
}

export const SessionExpiredOverlay: React.FC<SessionExpiredOverlayProps> = ({ onRelogin, message }) => {
  const theme = useTheme();

  return (
    <OverlayContainer>
      <StyledPaper elevation={1}>
        <ModalHeader>
          <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }}>
            You have been signed out
          </Typography>
          <IconButton size="small" onClick={onRelogin} aria-label="close">
            <CloseIcon fontSize="small" />
          </IconButton>
        </ModalHeader>

        <ModalContent>
          <Typography variant="body1" color="text.primary" sx={{ mb: 1 }}>
            {message ?? "You've been signed out of the application console. All sessions in all tabs have been signed out."}
          </Typography>
        </ModalContent>

        <ModalFooter>
          <Button
            variant="contained"
            onClick={onRelogin}
            sx={{
              borderRadius: '20px',
              backgroundColor: theme.palette.mode === 'dark' ? '#ffb400' : '#ff9900',
              color: '#000',
              fontWeight: 500,
              '&:hover': {
                backgroundColor: theme.palette.mode === 'dark' ? '#ffc233' : '#ffaa33',
              },
              padding: '6px 24px',
              textTransform: 'none',
              fontSize: '14px'
            }}
          >
            Sign in again
          </Button>
        </ModalFooter>
      </StyledPaper>
    </OverlayContainer>
  );
};

// import {
//   OverlayContainer,
//   StyledPaper,
//   Title,
//   Message,
//   StyledButton
// } from './sessionExpired.styled';

// interface SessionExpiredOverlayProps {
//   onRelogin: () => void;
// }

// export const SessionExpiredOverlay: React.FC<SessionExpiredOverlayProps> = ({ onRelogin }) => {
//   return (
//     <OverlayContainer>
//       <StyledPaper elevation={1}>
//         <Title>You have been signed out</Title>
//         <Message>
//           Your session has expired. Please click below to log back in and continue your work.
//         </Message>
//         <StyledButton
//           variant="contained"
//           onClick={onRelogin}
//         >
//           Log Back In
//         </StyledButton>
//       </StyledPaper>
//     </OverlayContainer>
//   );
// };